import React from 'react';
export function Footer() {
  return <footer className="border-t border-border bg-bg py-12" data-id="element-63">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12" data-id="element-64">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6 mb-8" data-id="element-65">
          {/* Logo */}
          <div className="font-archivo text-xl uppercase tracking-tight" data-id="element-66">
            THE AI <span className="text-brand" data-id="element-67">INCOME</span> BLUEPRINT
          </div>

          {/* Links */}
          <div className="flex items-center gap-6 font-mono text-sm uppercase tracking-wider text-ink-dim" data-id="element-68">
            <a href="#" className="hover:text-brand transition-colors" data-id="element-69">
              Privacy
            </a>
            <a href="#" className="hover:text-brand transition-colors" data-id="element-70">
              Terms
            </a>
            <a href="#" className="hover:text-brand transition-colors" data-id="element-71">
              Contact
            </a>
          </div>
        </div>

        {/* Copyright */}
        <div className="text-center md:text-left text-ink-dim/50 text-sm" data-id="element-72">
          © 2026 The AI Income Blueprint. Built with AI by Cesar Navarro.
        </div>
      </div>
    </footer>;
}